/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Speed_Auto_TitleInputs */

const en_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-calculated speed`)
};

const fr_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse calculée automatiquement`)
};

const de_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisch berechnete Geschwindigkeit`)
};

const it_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità calcolata automaticamente`)
};

const ru_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматически рассчитываемая скорость`)
};

const es_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad calculada automáticamente`)
};

const zh_cn2_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动计算速度`)
};

const ja_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動計算された速度`)
};

const hi_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वतः गणना की गई गति`)
};

const pt_pt2_audio_recorder_speed_auto_title = /** @type {(inputs: Audio_Recorder_Speed_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade calculada automaticamente`)
};

/**
* | output |
* | --- |
* | "Auto-calculated speed" |
*
* @param {Audio_Recorder_Speed_Auto_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_speed_auto_title = /** @type {((inputs?: Audio_Recorder_Speed_Auto_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Speed_Auto_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_speed_auto_title(inputs)
	if (locale === "de") return de_audio_recorder_speed_auto_title(inputs)
	if (locale === "it") return it_audio_recorder_speed_auto_title(inputs)
	if (locale === "ru") return ru_audio_recorder_speed_auto_title(inputs)
	if (locale === "es") return es_audio_recorder_speed_auto_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_speed_auto_title(inputs)
	if (locale === "ja") return ja_audio_recorder_speed_auto_title(inputs)
	if (locale === "hi") return hi_audio_recorder_speed_auto_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_speed_auto_title(inputs)
	return en_audio_recorder_speed_auto_title(inputs)
});